import sidebar from '@/config/sidebars/attribution'
import createVueApp from '@/common/createApp'

Styxie.Initializers.AttributionWidgets = {
  index: async(props) => {
    const { default: WidgetsIndex } = await import('@/vue_widgets/attribution/widgets/index.vue')
    createVueApp(WidgetsIndex, { props, sidebar })
  },
  show: async(props) => {
    const { default: WidgetsShow } = await import('@/vue_widgets/attribution/widgets/show.vue')
    createVueApp(WidgetsShow, { props, sidebar })
  },
  new: async(props) => {
    const { default: WidgetsForm } = await import('@/vue_widgets/attribution/widgets/form.vue')
    createVueApp(WidgetsForm, { props, sidebar })
  },
  edit: async(props) => {
    const { default: WidgetsForm } = await import('@/vue_widgets/attribution/widgets/form.vue')
    createVueApp(WidgetsForm, { props, sidebar })
  }
}
